export * from "firebase/analytics";

export const resetAnalyticsData = null; // this does not exist on web
